export const DATE_FORMAT = {
	default: 'MMM dd, yyyy'
};

export const TIME_FORMAT = {
	default: 'HH:mm:ss',
	hoursMinutesZeroSeconds: 'HH:mm:00'
};
